import React from 'react';

export default function StatusBadge({ status, size = 'md' }) {
  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2.5 py-1',
    lg: 'text-base px-3 py-1.5'
  };

  const getStatusColor = (status) => {
    if (!status) return 'bg-slate-700 text-slate-300';
    
    const statusLower = status.toLowerCase();
    
    if (statusLower === 'active' || statusLower === 'complete' || statusLower === 'repaired') {
      return 'bg-emerald-900/30 text-emerald-400 border-emerald-800';
    }
    if (statusLower.includes('repair') || statusLower === 'in repair') {
      return 'bg-blue-900/30 text-blue-400 border-blue-800';
    }
    if (statusLower.includes('approval') || statusLower.includes('inspection')) {
      return 'bg-amber-900/30 text-amber-400 border-amber-800';
    }
    if (statusLower === 'missing' || statusLower === 'scrapped' || statusLower.includes('failed')) {
      return 'bg-red-900/30 text-red-400 border-red-800';
    }
    if (statusLower.includes('transit') || statusLower === 'sent to vendor') {
      return 'bg-purple-900/30 text-purple-400 border-purple-800';
    }
    
    return 'bg-slate-700 text-slate-300 border-slate-600';
  };

  return (
    <span className={`${sizeClasses[size]} rounded-full border font-medium ${getStatusColor(status)}`}>
      {status || 'Unknown'}
    </span>
  );
}

